const state = {
  collapsed: false,
};

const getters = {
  isCollapsed: (state) => state.collapsed,
};

const mutations = {
  setCollapse(state, payload) {
    state.collapsed = payload;
  },
};

const actions = {
  changeCollapse(context, collapsedValue) {
    context.commit("setCollapse", collapsedValue);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
